//google Ads account ID also in public/index.html
export const GOOGLE_ADS_ID = "AW-11283522382";

//conversion labels (generated by Google Ads)
export const purchaseTag = `${GOOGLE_ADS_ID}/hfpICK6z7NcbEM7Gs4Qq`;//for purchase confirmation page
export const customTourTag = `${GOOGLE_ADS_ID}/mgaHCPeEhtgbEM7Gs4Qq`;//(Book appointment in ads) for custom tour form submission confirmation page in goo
export const callClickTag = `${GOOGLE_ADS_ID}/76n3CIyFs9gbEM7Gs4Qq`;//for call button clicks on contact page

export const addToCartTag = `${GOOGLE_ADS_ID}/aachCKOGpdgbEM7Gs4Qq`;//INACTIVE in code - automatic in Google Ads
export const viewTourPageTag = `${GOOGLE_ADS_ID}/akonCMmG9ssYEM7Gs4Q`;//INACTIVE in code - automatic in Google Ads
